import { queryOptions } from '@tanstack/react-query'

import { api, unwrap } from '@/lib/api/client'
import { publicApi } from '@/lib/api/public-client'

export const authQueries = {
  /** The signed-in user and their dealerships. Cleared on sign-out, reused across routes. */
  me: () =>
    queryOptions({
      queryKey: ['auth', 'me'] as const,
      queryFn: async () => unwrap(await api.GET('/api/v1/users/me')),
      staleTime: 5 * 60 * 1000,
      retry: false,
    }),
  /**
   * Whether sign-up is open on this deployment (`APP_REGISTRATION_OPEN`).
   *
   * On `publicApi`, for the reason the join page uses it: nobody reading this has a session
   * worth sending, and a stale token on this browser must not be spent — or dropped — on it.
   * `staleTime: Infinity` because it is a deployment setting rather than data: it changes with
   * a restart, and a reload is what a reader does after one.
   */
  registration: () =>
    queryOptions({
      queryKey: ['auth', 'registration'] as const,
      queryFn: async ({ signal }) =>
        unwrap(await publicApi.GET('/api/v1/auth/registration', { signal })),
      staleTime: Infinity,
      retry: false,
    }),
}
